type OnboardingUrlOptions = {
  next?: string;
};

export function safeLocalPath(value: string | null | undefined, fallback = '/new-trip') {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return fallback;

  try {
    const url = new URL(value, 'https://roamtogether.local');
    if (url.origin !== 'https://roamtogether.local') return fallback;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}

export function buildOnboardingUrl({ next = '/new-trip' }: OnboardingUrlOptions = {}) {
  const safe = safeLocalPath(next);
  // If the caller already handed us an /onboarding URL (e.g. the
  // Explore "Use this trip" button building its own onboarding intent),
  // pass it through verbatim instead of nesting another /onboarding
  // wrapper around it — that double-wrap caused Clerk to reject the
  // redirect target and silently unmount the widget.
  if (
    safe === '/onboarding' ||
    safe.startsWith('/onboarding?') ||
    safe.startsWith('/onboarding/')
  ) {
    return safe;
  }
  const params = new URLSearchParams();
  params.set('next', safe);
  return `/onboarding?${params.toString()}`;
}

/** Signup redirect: Kiersten gift guides open right after account creation. */
export function buildSignupRedirectUrl({ next = '/new-trip' }: OnboardingUrlOptions = {}) {
  const safe = safeLocalPath(next);
  if (safe === '/guides' || safe.startsWith('/guides/')) {
    return safe;
  }
  if (safe.startsWith('/join/email-invite/')) {
    return safe;
  }
  return buildOnboardingUrl({ next: safe });
}

export function buildExploreSnapshotOnboardingUrl(slug: string) {
  return buildOnboardingUrl({
    next: `/new-trip?explore=${encodeURIComponent(slug)}`,
  });
}

export function readOnboardingRedirect(search: string) {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);

  return {
    next: safeLocalPath(params.get('next')),
  };
}
